import { useState } from 'react';

let count = 0;

const useIdCounter = (prefix = '') => {
  const [counter] = useState(() => count++);

  return [prefix, `${counter}`].filter(Boolean).join('-');
};

export default useIdCounter;
